import { useFocusEffect } from '@react-navigation/native';
import { setStatusBarStyle, StatusBarStyle } from 'expo-status-bar';

interface IUseStatusBarParams {
  onFocus?: StatusBarStyle;
  onBlur?: StatusBarStyle;
}

export function useFocusStatusBar({
  onFocus,
  onBlur,
}: IUseStatusBarParams) {
  useFocusEffect(() => {
    if (onFocus) {
      setStatusBarStyle(onFocus);
    }

    return () => {
      if (onBlur) {
        setStatusBarStyle(onBlur);
      }
    };
  });
}

export function useFocusStatusBarOneTimeLight() {
  useFocusStatusBar({ onFocus: 'light', onBlur: 'dark' });
}
